module.exports = __webpack_public_path__ + "static/media/eris.62976162.png";